/** Import CMS DLOs */
import { cms } from "./cms";
import { core } from "./core";

// Exportable DLOs
export const dlos = {
    cms,
    core
};
